var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopingArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1833_11577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 22.5C8.82843 22.5 9.5 21.8284 9.5 21C9.5 20.1716 8.82843 19.5 8 19.5C7.17157 19.5 6.5 20.1716 6.5 21C6.5 21.8284 7.17157 22.5 8 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.5C19.3284 22.5 20 21.8284 20 21C20 20.1716 19.3284 19.5 18.5 19.5C17.6716 19.5 17 20.1716 17 21C17 21.8284 17.6716 22.5 18.5 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.4H7.19658L6.62258 13.6H19.9988C20.1949 13.6045 20.3865 13.5411 20.5411 13.4205C20.6961 13.2996 20.8044 13.1287 20.8476 12.937L20.8476 12.9367L22.3475 6.18703C22.376 6.06091 22.3754 5.92996 22.3456 5.80413C22.3158 5.67831 22.2578 5.56093 22.1758 5.46094C22.0938 5.36094 21.9901 5.28096 21.8726 5.22708C21.7555 5.17338 21.6276 5.14703 21.4988 5.15H4.94736L4.34815 2.08084L4.34815 2.08084L4.34798 2.08002C4.30825 1.88514 4.20142 1.71036 4.04611 1.58611C3.89107 1.46208 3.69751 1.39624 3.49902 1.4H0.5H0.4V1.5V3V3.1H0.5H2.80294L5.65192 17.4195L5.65202 17.42C5.69175 17.6149 5.79858 17.7896 5.95389 17.9139C6.10892 18.0379 6.30246 18.1038 6.50094 18.1H20H20.1V18V16.5V16.4H20ZM20.4379 6.85L19.3197 11.9H6.29698L5.28698 6.85H20.4379Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1833_11577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopingArt);
export default __webpack_public_path__ + "static/media/shoping-сart.bdf1e47a79699c7af0e9375fbf71b79d.svg";
export { ForwardRef as ReactComponent };